import React, { useState } from "react";
import api from "../../api";

// Lucide Icons
import {
  Mail,
  Send,
  Shield,
  AlertCircle,
  Loader2,
  UserCog,
  KeyRound,
  ArrowRight,
  CheckCircle,
} from "lucide-react";
import "./AdminForgetPass.css";

function AdminForgetPass({ match }) {
  const [email, setEmail] = useState("");
  const [loader, setLoader] = useState(false);
  const [isSent, setIsSent] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async () => {
    try {
      if (!email) {
        setError("Please enter an email address");
        return;
      }

      setError("");
      setLoader(true);

      const payload = { email };
      const userData = await api.forgetPass(payload);

      if (userData.success) {
        setIsSent(true);
        setEmail("");
        alert(userData.message);
      } else {
        setError("Something went wrong, email not sent");
      }
    } catch (error) {
      console.log(error);
      setError("Something went wrong, email not sent");
    } finally {
      setLoader(false);
    }
  };

  const handleReset = () => {
    setIsSent(false);
    setEmail("");
    setError("");
  };

  return (
    <>
      <div className="admin-forget-pass-container">
        <div className="admin-forget-pass-content">
          {/* Header Section */}
          <div className="admin-forget-pass-header">
            <div className="admin-forget-pass-header-icon">
              <UserCog size={40} />
            </div>
            <h1 className="admin-forget-pass-title">
              Send Password Reset Email
            </h1>
            <p className="admin-forget-pass-subtitle">
              Send password reset instructions to user's email address
            </p>
          </div>

          {/* Main Content */}
          <div className="admin-forget-pass-card">
            {isSent ? (
              /* Success State */
              <div className="admin-forget-pass-success">
                <div className="admin-forget-pass-success-icon">
                  <CheckCircle size={48} />
                </div>
                <h2 className="admin-forget-pass-success-title">
                  Email Sent Successfully
                </h2>
                <p className="admin-forget-pass-success-message">
                  Password reset instructions have been sent to the user's email
                  address. They will receive a secure link to reset their
                  password.
                </p>
                <div className="admin-forget-pass-success-actions">
                  <button
                    className="admin-forget-pass-success-button"
                    onClick={handleReset}
                  >
                    <ArrowRight
                      size={18}
                      style={{ transform: "rotate(180deg)" }}
                    />
                    Send Another Email
                  </button>
                </div>
              </div>
            ) : (
              /* Form Section */
              <div className="admin-forget-pass-form">
                <div className="admin-forget-pass-input-section">
                  <div className="admin-forget-pass-input-header">
                    <Mail className="admin-forget-pass-input-header-icon" />
                    <label className="admin-forget-pass-input-label">
                      User Email Address
                    </label>
                  </div>

                  <div className="admin-forget-pass-input-wrapper">
                    <Mail className="admin-forget-pass-input-icon" size={20} />
                    <input
                      type="email"
                      className="admin-forget-pass-input"
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                        setError("");
                      }}
                      placeholder="Enter user's email address..."
                      onKeyPress={(e) => e.key === "Enter" && handleSubmit()}
                    />
                  </div>

                  {error && (
                    <div className="admin-forget-pass-error">
                      <AlertCircle size={16} />
                      <span>{error}</span>
                    </div>
                  )}

                  <div className="admin-forget-pass-input-hint">
                    <Shield size={14} />
                    <span>
                      The user will receive a secure password reset link
                    </span>
                  </div>
                </div>

                <button
                  onClick={handleSubmit}
                  className="admin-forget-pass-submit-button"
                  disabled={loader}
                >
                  {loader ? (
                    <>
                      <Loader2 className="admin-forget-pass-loader" size={20} />
                      Sending Email...
                    </>
                  ) : (
                    <>
                      <Send size={20} />
                      Send Password Reset Email
                    </>
                  )}
                </button>

                {/* <div className="admin-forget-pass-security-note">
                  <KeyRound size={16} />
                  <div>
                    <strong>Security Note:</strong> Reset links expire in 1 hour and can only be used once.
                  </div>
                </div> */}
              </div>
            )}

            {/* Stats/Info Section */}
            {/* <div className="admin-forget-pass-info">
              <div className="admin-forget-pass-info-item">
                <div className="admin-forget-pass-info-icon">
                  <Shield size={18} />
                </div>
                <div className="admin-forget-pass-info-content">
                  <span className="admin-forget-pass-info-label">Secure Process</span>
                  <span className="admin-forget-pass-info-value">Encrypted Reset Link</span>
                </div>
              </div>
              <div className="admin-forget-pass-info-item">
                <div className="admin-forget-pass-info-icon">
                  <Mail size={18} />
                </div>
                <div className="admin-forget-pass-info-content">
                  <span className="admin-forget-pass-info-label">Email Delivery</span>
                  <span className="admin-forget-pass-info-value">Instant Send</span>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
}

export default AdminForgetPass;
